<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <NavbarTwo />
    </div>

    <div class="content-wrapper">
      <PageBanner pageTitle="Service Details" mainTitle="Service Details" />
      <ServiceDetails />
    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layouts/TopHeader.vue";
import NavbarTwo from "../Layouts/NavbarTwo.vue";
import PageBanner from "../Common/PageBanner.vue";
import ServiceDetails from "../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "ServiceDetailspage",
  components: {
    TopHeader,
    NavbarTwo,
    PageBanner,
    ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>